import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { APP_NODE_ID } from "../../app.defaults";
import {
  selectWorkspaces,
  selectWorkspacesPagination,
} from "../../state/workspaces/workspaces.selector";
import Styles from "./WorkspaceLayout.module.css";

interface WorkspacesLayoutProps {
  loadNextPage?: () => void;
}

export const WorkspacesLayout = ({
  children,
  loadNextPage,
}: React.PropsWithChildren<WorkspacesLayoutProps>) => {
  const { data } = useSelector(selectWorkspacesPagination);
  const myWorkspaceMetadata = useSelector(selectWorkspaces);

  return (
    <InfiniteScroll
      className={Styles.infiniteScroll}
      dataLength={myWorkspaceMetadata.length}
      hasMore={!!data?.offset}
      loader=""
      next={() => loadNextPage?.()}
      scrollableTarget={APP_NODE_ID}
    >
      {React.Children.map(
        children,
        (child) =>
          React.isValidElement(child) && (
            <div className={Styles.card} key={child.key}>
              {child}
            </div>
          ),
      )}
    </InfiniteScroll>
  );
};
